var _rect, _circle, _path, _text;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAthenahealth(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 240 60",
    role: "img",
    "aria-label": "athenahealth",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 1,
    width: 238,
    height: 58,
    rx: 10,
    fill: "none",
    stroke: "#cbd5e1",
    strokeWidth: 1.2
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 28,
    cy: 30,
    r: 11,
    fill: "#5b2a86"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22 33 L28 22 L34 33 Z",
    fill: "#ffffff"
  })), _text || (_text = /*#__PURE__*/React.createElement("text", {
    x: 48,
    y: 38,
    fontFamily: "Helvetica, Arial, sans-serif",
    fontSize: 22,
    fontWeight: 600,
    fill: "#5b2a86",
    letterSpacing: -0.5
  }, "athena", /*#__PURE__*/React.createElement("tspan", {
    fontWeight: 300,
    fill: "#7a54a0"
  }, "health"))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAthenahealth);
export default __webpack_public_path__ + "static/media/athenahealth.e5cdb7c76239fd0b484acc6e2d04f7f7.svg";
export { ForwardRef as ReactComponent };